// frontend/src/components/HourHeatmap.tsx
import { Fragment } from "react";

export interface HourCell {
  hour: number;       // 0-23
  dayOfWeek: number;  // 0=Sun..6=Sat
  value: number;
}

export interface HourHeatmapProps {
  cells: HourCell[];
  metric?: "revenue" | "purchases" | "visits" | "buyout_rate";
}

const DAYS = ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"];

export function HourHeatmap({ cells }: HourHeatmapProps) {
  const max = Math.max(...cells.map((c) => c.value), 1);
  const grid: number[][] = Array.from({ length: 7 }, () => Array(24).fill(0));
  for (const c of cells) {
    if (c.dayOfWeek >= 0 && c.dayOfWeek < 7 && c.hour >= 0 && c.hour < 24) {
      grid[c.dayOfWeek][c.hour] = c.value;
    }
  }

  function cellColor(v: number): string {
    if (v === 0) return "var(--surface-muted)";
    const intensity = Math.min(1, v / max);
    return `rgba(110, 231, 183, ${0.15 + intensity * 0.7})`;
  }

  return (
    <div style={{ display: "grid", gridTemplateColumns: "32px repeat(24, 1fr)", gap: 2 }}>
      <div />
      {Array.from({ length: 24 }).map((_, h) => (
        <div key={`col-${h}`} style={{ fontSize: 9, color: "var(--text-muted)", textAlign: "center" }}>
          {h % 3 === 0 ? h : ""}
        </div>
      ))}
      {DAYS.map((day, dow) => (
        <Fragment key={`row-${dow}`}>
          <div style={{ fontSize: 11, color: "var(--text-secondary)", padding: "4px 0" }}>{day}</div>
          {Array.from({ length: 24 }).map((_, h) => {
            const v = grid[dow][h];
            return (
              <div
                key={`${dow}-${h}`}
                title={`${day} ${h}:00 → ${v.toLocaleString("ru-RU")}`}
                style={{
                  aspectRatio: "1",
                  background: cellColor(v),
                  borderRadius: 2,
                  boxShadow: v > max * 0.7 ? "0 0 8px rgba(110, 231, 183, 0.3)" : "none",
                  cursor: "default",
                  transition: "transform 0.1s",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = "scale(1.2)"; e.currentTarget.style.zIndex = "1"; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.zIndex = ""; }}
              />
            );
          })}
        </Fragment>
      ))}
    </div>
  );
}
